// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"72e33923","255":"0af50205","426":"9f7f760e","937":"c82d0062"}[chunkId] + ".chunk.js";
};